import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'

export const prepareRowsForDownload = (data = {}) => {
  if (isEmpty(data)) {
    return []
  }

  const rowsToRender = []
  const packageTypes = Object.keys(data)
  packageTypes.forEach(keyName => {
    rowsToRender.push({
      key: keyName,
      subRows: get(data, `${keyName}`, []),
    })
  })

  return rowsToRender
}
